import React, { useMemo } from "react";
import { RiCalendarScheduleLine } from "@remixicon/react";
import Button from "../../../theme/button/Button";
import TimeDisplay from "../../../time/Time";
import { TicketMessage } from "../../../../__generated__/api";
import Styles from "./ScheduleInfo.module.scss";

interface ScheduleInfoProps {
    scheduledMessages: TicketMessage[];
    newMessageDate?: Date;
    onCancel: () => void;
    onSwitchView: () => void;
}

export default function ScheduleInfo({
    newMessageDate, onCancel, scheduledMessages, onSwitchView,
}: ScheduleInfoProps) {
    const cancelButton = useMemo(() => (newMessageDate && (
        <Button variant="none" size="small" onClick={onCancel} className={Styles.action}>
            Cancel
        </Button>
    )), [newMessageDate, onCancel]);

    const viewButton = useMemo(() => (scheduledMessages.isNotEmpty && (
        <Button variant="none" size="small" onClick={onSwitchView} className={Styles.action}>
            View
            {scheduledMessages.isNotEmpty && " All"}
        </Button>
    )), [scheduledMessages, onSwitchView]);

    const firstMessage = scheduledMessages.firstElement;

    if (!cancelButton && !viewButton) {
        return null;
    }

    return (
        <div className={Styles["schedule-info"]}>
            <div className={Styles.message}>
                <RiCalendarScheduleLine />
                {newMessageDate ? (
                    <>
                        {" Once sent, message will be scheduled for "}
                        <span className={Styles.strong}><TimeDisplay date={newMessageDate} variant="date" /></span>
                        {" at "}
                        <span className={Styles.strong}><TimeDisplay date={newMessageDate} variant="time" /></span>
                    </>
                ) : (
                    <>
                        {scheduledMessages.length === 1 ? (
                            " 1 scheduled message for "
                        ) : (
                            ` ${scheduledMessages.length} messages, starting from `
                        )}
                        <span className={Styles.strong}><TimeDisplay date={firstMessage.schedule?.date} variant="date" /></span>
                        {" at "}
                        <span className={Styles.strong}><TimeDisplay date={firstMessage.schedule?.date} variant="time" /></span>
                    </>
                )}
            </div>
            <div>
                {cancelButton}
                {viewButton}
            </div>
        </div>
    );
}

ScheduleInfo.defaultProps = {
    newMessageDate: undefined,
};
